<template>
  <a-modal
    :title="$t('page_mini_auth')+'（'+ customerInfo.name +'）'"
    width="700px"
    :visible="value"
    @cancel="cancel"
    @ok="ok"
    :confirmLoading="confirmLoading"
  >
    <ml-table
      :scroll="{ y: `300px` }"
      :columns="columns"
      :dataSource="tableData"
      childrenColumnName="none"
      :canChangeColWidth="false"
      rowKey="id"
      >
        <template slot="name" slot-scope="text, record">
          <a-checkbox :checked="checkedKeys.includes(record.id)" :value="record.id" @change="e=>handleCheckboxChange(e,record)">
            {{text}}
          </a-checkbox>
        </template>
        <template v-if="record.children" slot="sub" slot-scope="_, record">
          <a-checkbox :checked="checkedKeys.includes(i.id)" v-for="i in record.children" :key="i.id" :value="i.id" @change="e=>handleCheckboxChange(e,i)">
            {{i.name}}
          </a-checkbox>
        </template>
      </ml-table>
  </a-modal>
</template>

<script>
import { CustomerMenuServiceProxy, CustomerRoleServiceProxy } from '@/service-proxies/app-v2/client.service-proxies';
const customerApi = new CustomerMenuServiceProxy();
const customerRoleApi = new CustomerRoleServiceProxy();
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    customerInfo: Object,
  },
  data() {
    return {
      confirmLoading: false,
      tableData: [],
      checkedKeys: []
    }
  },
  watch: {
    value(bool) {
      if(bool){
        this.getAuth(this.customerInfo.id);
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("function_permission"),
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: this.$t("page_sub_permission"),
          dataIndex: "sub",
          key: "sub",
          scopedSlots: { customRender: "sub" },
        },
      ]
    }
  },
  created() {
    customerApi.grantTree().then(res=>{
      this.tableData = res;
    })
  },
  methods: {
    getAuth(id) {
      customerApi.getRoleGrantIds(id).then(data=>{
        this.checkedKeys = data;
      })
    },
    handleCheckboxChange(e, row) {
      const {value} = e.target;
      const bool = this.checkedKeys.includes(value);
      this.setCheckedKeys(value, !bool);
      if(row.hasChildren) {
        row.children.map(v=>{
          this.setCheckedKeys(v.id, !bool);
        });
      }
    },
    setCheckedKeys(key, isChecked) {
      if(isChecked) {
        const isExist = this.checkedKeys.includes(key);
        if(!isExist) this.checkedKeys.push(key);
      } else {
        const index = this.checkedKeys.indexOf(key)
        if(index!==-1) this.checkedKeys.splice(index, 1);
      }
    },
    ok(){
      this.confirmLoading = true;
      customerRoleApi.grant({customerId: this.customerInfo.id, menuIds: this.checkedKeys}).then(res=>{
        this.$message.success(this.$t('page_resource_pool_success'));
        this.cancel();
      }).finally(()=>{
        this.confirmLoading = false;
      });
    },
    cancel(){
      this.checkedKeys = [];
      this.$emit('input', false);
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-modal-header, /deep/ .ant-modal-footer {
  background: #f8f8f8;
}
</style>
